import React from "react";
import PageRenderer from "../components/PageRender";

const Contatti = () => {
  return <PageRenderer pageIdentifier="offerte" />;
};

export default Contatti;
